import { formatDate } from './formatDate';
import validateReponse from './validateResponse';

const poll = async ({ fn, interval = 4000, maxAttempts = 15, errorFn, setFn, loadingFn }) => {
  let attempts = 0;

  const executePoll = async (resolve, reject) => {
    const result = await fn();
    attempts++;

    if (result && validateReponse(result)) {
      if (validateReponse(result) === 'failed') {
        errorFn('An error occurred');
      } else {
        const data = result.data;

        let updatedData = data;
        if (data.progress === 100 && data.state === 'completed' && data.metadata.isChronological) {
          updatedData.queryResult = updatedData.queryResult?.map(series => {
            const updatedSeries = { ...series };
            if (series.metadata.x[0]?.isDate) {
              const newData = series.data.map(dataPoint => {
                const keys = Object.keys(dataPoint);
                const xKey = keys[0];
                const yKey = keys[1];

                // handle other unit types too based on queryConstruct
                return { [xKey]: formatDate(dataPoint[xKey], 'month'), [yKey]: dataPoint[yKey] };
              });

              updatedSeries.data = newData;
            }

            return updatedSeries;
          });
        }
        setFn(updatedData);
      }
      loadingFn(false);
      return resolve(result);
    } else if (maxAttempts && attempts === maxAttempts) {
      return reject(new Error('Exceeded max attempts'));
    } else {
      setTimeout(executePoll, interval, resolve, reject);
    }
  };

  try {
    // eslint-disable-next-line no-undef
    const result = await new Promise(executePoll);
    return result;
  } catch (e) {
    throw new Error(e);
  }
};

export default poll;
